import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import icons from './icons/_index.jsx';
import createKey from '../../util/createKey.js';

export default function LdsIcon({
  name,
  inline = false,
  decorative,
  description,
  label,
  className,
  ...rest
}) {
  const Icon = icons[name];
  const [iconId, setIconId] = useState('');

  useEffect(() => (setIconId(createKey())), []);

  return (
    <svg
      className={cn(
        'lds-icon',
        `icon-${name}`,
        {
          inline,
        },
        className
      )}
      aria-hidden={decorative}
      role="img"
      focusable="false"
      aria-labelledby={`lds-icon-${name}-title-${iconId} lds-icon-${name}-description-${iconId}`}
      {...rest}
    >
      <title
        id={`lds-icon-${name}-title-${iconId}`}
      >
        {label || name}
      </title>
      <desc
        id={`lds-icon-${name}-description-${iconId}`}
      >
        {description}
      </desc>
      <Icon />
    </svg>
  );
}

LdsIcon.propTypes = {
  name: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  decorative: PropTypes.bool,
  description: PropTypes.string,
  fill: PropTypes.string,
  label: PropTypes.string,
};
